import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Notification extends Vue {

    private isDismissed = false;

    private dismiss(): void {
        this.isDismissed = true;
        // this.$buefy.snackbar.open({
        //     message: 'Dismissed',
        //     queue: false,
        // });
    }
}